import AmpWrap from '@components/atoms/amp/AmpWrap';
import { Heading2 } from 'components/atoms/Typography';
import { linkResolver } from 'lib/data/prismic/helpers';
import Image from 'next/image';
import Link from 'next/link';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { Post } from 'types/frontEndTypes';
import CategoryLink from './CategoryLink';

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 76px;
  padding: 0 20px;

  width: 33.3333%;

  h2 {
    font-size: 36px;
    margin: 0 0 17px;
    min-height: 72px;
  }

  p {
    margin: 0 0 25px;
    line-height: 1.7;
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    margin-bottom: 40px;
    h2 {
      font-size: 26px;
      min-height: auto;
    }
  }
`;

const Thumbnail = styled.div`
  position: relative;
  width: 100%;
  height: 209px;
  background-color: #ececec;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
  background-position: center;
  background-size: cover;
`;

const PostItem = ({ post }: { post: Post }) => {
  const title = RichText.asText(post.data.title)
    ? RichText.asText(post.data.title)
    : 'Untitled';

  return (
    <Wrapper>
      <Link href={linkResolver(post)}>
        <a>
          <Thumbnail>
            <AmpWrap
              ampOnly={
                <amp-img
                  alt={post.data.image.alt}
                  src={post.data.image.url}
                  width={post.data.image?.dimensions?.width}
                  height={post.data.image?.dimensions?.height}
                  layout="responsive"
                />
              }
              nonAmp={
                <>
                  {post.data.image.url && (
                    <Image
                      alt={post.data.image.alt}
                      src={post.data.image.url}
                      layout="fill"
                      objectFit="cover"
                      quality={25}
                    />
                  )}
                </>
              }
            />
          </Thumbnail>
          <Heading2>{title}</Heading2>
          <p>{post.data.description}</p>
        </a>
      </Link>
      {post.data.categories.map(({ category }) =>
        category?.uid ? (
          <CategoryLink category={category} key={category?.uid} />
        ) : null,
      )}
    </Wrapper>
  );
};

export default PostItem;
